module.exports = __webpack_public_path__ + "static/media/iconTakeatClube.57cb11b7.png";